import Api from "../utils/Api";
import * as types from "./Types";

export const loginAsAdmin = (password) => {
  return (dispatch, getState) => {
    const state = getState();

    return Api.post(`/members/login_as_admin`, { password }).then((resp) => {
      dispatch(setLoginCredentials(resp));
    });
  };
};

export const setLoginCredentials = ({
  name,
  phoneNumber,
  countryCode,
  authToken,
  memberId,
  imageUrl,
  isAdmin = false,
  location,
  canSendFromLiveLocation,
}) => ({
  type: types.SET_LOGIN_CREDENTIALS,
  name,
  phoneNumber,
  countryCode,
  authToken,
  memberId,
  imageUrl,
  isAdmin,
  location,
  canSendFromLiveLocation,
});

export const logout = () => {
  return (dispatch) => {
    if (typeof window !== "undefined") {
      window.localStorage.removeItem("persist:root");
    }

    dispatch({ type: types.RESET_STATE });
  };
};
